import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserConstant } from 'src/app/shared/constants/user-constant';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(public router: Router, public activatedRoute: ActivatedRoute) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    try {
      let tmp = JSON.parse(localStorage.getItem(UserConstant.USER));
      if (tmp['role']>=0) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      const isCellularReport = state && state.url
        && state.url.indexOf('/layout/report/cellular-reports') === 0;
      if (isCellularReport) {
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      } else {
        this.router.navigate(['/login']);
      }
      return false;
    }
  }
}
